const stages = {
  frontend: {
    base: '',
    frtenid: process.env.FRLANGTENID,
    public: process.env.REACT_APP_CDN_URL,
    loginRoot: process.env.REACT_APP_LOGIN_URL,
    logoutRoot: process.env.REACT_APP_LOGOUT_URL,
    cmsRoot: process.env.GRAPH_CMS_URL,
    accountsGateway: process.env.REACT_APP_ACCOUNTS_URL,
    accountsBasePath: process.env.REACT_APP_ACCOUNTS_BASE_URL,
    ticketingRoot: process.env.REACT_APP_TICKETING_URL,
    ticketGateway: process.env.REACT_APP_TICKET_URL,
    rmmGateway: process.env.REACT_APP_RMM_URL,
    rmmRoot: process.env.REACT_APP_ROOT_RMM_URL,
    fileRoot: process.env.REACT_APP_FILE_SERVICE_URL,
    apiGateway: '/api',
    camGateway: process.env.REACT_APP_CAM_URL,
    galaxyRoot: '/galaxy',
    imageRoot: process.env.PUBLIC_URL
      ? `${process.env.PUBLIC_URL}${process.env.REACT_APP_CDN_SUFFIX}`
      : process.env.PUBLIC_URL,
    camRoot: '/packages/banyan/build/',
    ticketRoot: '/packages/mangifera/build/',
    intercomAppID: process.env.INTERCOM_APP_ID,
    mode: process.env.APP_MODE,
    chargeBeeEnv: process.env.CHARGEBEE_ENV,
    launchDarklyClientID: process.env.LAUNCHDARKLY_CLIENT_SITE_ID,
    cityLambdaURL: process.env.LAMBDA_CITY_URL,
    cannyBoardToken: process.env.CANNY_BOARDTOKEN,
    cannyForumToken: process.env.CANNY_FORUMTOKEN,
    cannyAppId: process.env.CANNY_APPID,
    lambdaURL: process.env.LAMBDA_URL,
    websocket: process.env.WEBSOCKET_URL,
    dromoFrontendKey: process.env.DROMO_FRONT_END_KEY,
    sentryUrl: process.env.SENTRY_URL,
    mixpanelKey: process.env.MIXPANEL_KEY,
    useranalyticsDomain: process.env.USER_ANALYTICS_DOMAIN,
    staticFileVersion: process.env.STATIC_FILE_VERSION,
    mlGateway: process.env.REACT_APP_ML_URL,
    apiDomainUrl: process.env.DOMAIN_NAME_URL,
    // Coralogix RUM Configuration
    coralogixRumPublicKey: process.env.REACT_APP_CORALOGIX_RUM_PUBLIC_KEY,
    coralogixApplicationName: process.env.REACT_APP_CORALOGIX_APPLICATION_NAME,
    coralogixSubsystemName: process.env.REACT_APP_CORALOGIX_SUBSYSTEM_NAME,
    coralogixAppVersion: process.env.REACT_APP_CORALOGIX_APP_VERSION,
    coralogixDomain: process.env.REACT_APP_CORALOGIX_DOMAIN
  },
  development: {
    base: '',
    frtenid: process.env.FRLANGTENID,
    public: process.env.REACT_APP_CDN_URL,
    loginRoot: process.env.REACT_APP_LOGIN_URL,
    logoutRoot: process.env.REACT_APP_LOGOUT_URL,
    cmsRoot: process.env.GRAPH_CMS_URL,
    camGateway: process.env.REACT_APP_CAM_URL,
    accountsGateway: process.env.REACT_APP_ACCOUNTS_URL,
    accountsBasePath: process.env.REACT_APP_ACCOUNTS_BASE_URL,
    ticketingRoot: process.env.REACT_APP_TICKETING_URL,
    ticketGateway: process.env.REACT_APP_TICKET_URL,
    rmmGateway: process.env.REACT_APP_RMM_URL,
    rmmRoot: process.env.REACT_APP_ROOT_RMM_URL,
    mockTicketGateway: process.env.REACT_APP_MOCK_TICKET_GATEWAY,
    mockRMMGateway: process.env.REACT_APP_MOCK_RMM_GATEWAY,
    fileRoot: process.env.REACT_APP_FILE_SERVICE_URL,
    apiPath: '',
    camRoot: 'cam',
    galaxyRoot: '/',
    hrefRoot: 'cam/',
    imageRoot: 'https://mylocaldev.superopsalpha.com:5553/',
    ticketRoot: '/',
    intercomAppID: process.env.INTERCOM_APP_ID,
    mode: process.env.APP_MODE,
    chargeBeeEnv: process.env.CHARGEBEE_ENV,
    launchDarklyClientID: process.env.LAUNCHDARKLY_CLIENT_SITE_ID,
    cityLambdaURL: process.env.LAMBDA_CITY_URL,
    stripePublicKey: process.env.STRIPE_PUBLIC_KEY,
    lambdaURL: process.env.LAMBDA_URL,
    cannyBoardToken: process.env.CANNY_BOARDTOKEN,
    cannyForumToken: process.env.CANNY_FORUMTOKEN,
    cannyAppId: process.env.CANNY_APPID,
    websocketURL: process.env.WEBSOCKET_URL,
    dromoFrontendKey: process.env.DROMO_FRONT_END_KEY,
    sentryUrl: process.env.SENTRY_URL,
    mixpanelKey: process.env.MIXPANEL_KEY,
    useranalyticsDomain: process.env.USER_ANALYTICS_DOMAIN,
    staticFileVersion: process.env.STATIC_FILE_VERSION,
    mlGateway: process.env.REACT_APP_ML_URL,
    apiDomainUrl: process.env.DOMAIN_NAME_URL,
    // Coralogix RUM Configuration
    coralogixRumPublicKey: process.env.REACT_APP_CORALOGIX_RUM_PUBLIC_KEY,
    coralogixApplicationName: process.env.REACT_APP_CORALOGIX_APPLICATION_NAME,
    coralogixSubsystemName: process.env.REACT_APP_CORALOGIX_SUBSYSTEM_NAME,
    coralogixAppVersion: process.env.REACT_APP_CORALOGIX_APP_VERSION,
    coralogixDomain: process.env.REACT_APP_CORALOGIX_DOMAIN
  },
  production: {
    base: '',
    frtenid: process.env.FRLANGTENID,
    public: process.env.REACT_APP_CDN_URL,
    loginRoot: process.env.REACT_APP_LOGIN_URL,
    logoutRoot: process.env.REACT_APP_LOGOUT_URL,
    cmsRoot: process.env.GRAPH_CMS_URL,
    accountsGateway: process.env.REACT_APP_ACCOUNTS_URL,
    accountsBasePath: process.env.REACT_APP_ACCOUNTS_BASE_URL,
    ticketingRoot: process.env.REACT_APP_TICKETING_URL,
    ticketGateway: process.env.REACT_APP_TICKET_URL,
    rmmGateway: process.env.REACT_APP_RMM_URL,
    rmmRoot: process.env.REACT_APP_ROOT_RMM_URL,
    fileRoot: process.env.REACT_APP_FILE_SERVICE_URL,
    apiGateway: '/api',
    camGateway: process.env.REACT_APP_CAM_URL,
    galaxyRoot: '/galaxy',
    imageRoot: process.env.PUBLIC_URL
      ? `${process.env.PUBLIC_URL}${process.env.REACT_APP_CDN_SUFFIX}`
      : process.env.PUBLIC_URL,
    camRoot: '/packages/banyan/build/',
    ticketRoot: '/packages/mangifera/build/',
    intercomAppID: process.env.INTERCOM_APP_ID,
    mode: process.env.APP_MODE,
    chargeBeeEnv: process.env.CHARGEBEE_ENV,
    launchDarklyClientID: process.env.LAUNCHDARKLY_CLIENT_SITE_ID,
    cityLambdaURL: process.env.LAMBDA_CITY_URL,
    stripePublicKey: process.env.STRIPE_PUBLIC_KEY,
    cannyAppId: process.env.CANNY_APP_ID,
    cannyBoardToken: process.env.CANNY_BOARDTOKEN,
    cannyForumToken: process.env.CANNY_FORUMTOKEN,
    lambdaURL: process.env.LAMBDA_URL,
    websocketURL: process.env.WEBSOCKET_URL,
    dromoFrontendKey: process.env.DROMO_FRONT_END_KEY,
    sentryUrl: process.env.SENTRY_URL,
    mixpanelKey: process.env.MIXPANEL_KEY,
    useranalyticsDomain: process.env.USER_ANALYTICS_DOMAIN,
    staticFileVersion: process.env.STATIC_FILE_VERSION,
    mlGateway: process.env.REACT_APP_ML_URL,
    apiDomainUrl: process.env.DOMAIN_NAME_URL,
    // Coralogix RUM Configuration
    coralogixRumPublicKey: process.env.REACT_APP_CORALOGIX_RUM_PUBLIC_KEY,
    coralogixApplicationName: process.env.REACT_APP_CORALOGIX_APPLICATION_NAME,
    coralogixSubsystemName: process.env.REACT_APP_CORALOGIX_SUBSYSTEM_NAME,
    coralogixAppVersion: process.env.REACT_APP_CORALOGIX_APP_VERSION,
    coralogixDomain: process.env.REACT_APP_CORALOGIX_DOMAIN
  },
  alpha: {
    base: '',
    frtenid: process.env.FRLANGTENID,
    public: process.env.REACT_APP_CDN_URL,
    loginRoot: process.env.REACT_APP_LOGIN_URL,
    logoutRoot: process.env.REACT_APP_LOGOUT_URL,
    cmsRoot: process.env.GRAPH_CMS_URL,
    accountsGateway: process.env.REACT_APP_ACCOUNTS_URL,
    accountsBasePath: process.env.REACT_APP_ACCOUNTS_BASE_URL,
    ticketingRoot: process.env.REACT_APP_TICKETING_URL,
    ticketGateway: process.env.REACT_APP_TICKET_URL,
    rmmGateway: process.env.REACT_APP_RMM_URL,
    mockTicketGateway: process.env.REACT_APP_MOCK_TICKET_GATEWAY,
    mockRMMGateway: process.env.REACT_APP_MOCK_RMM_GATEWAY,
    rmmRoot: process.env.REACT_APP_ROOT_RMM_URL,
    fileRoot: process.env.REACT_APP_FILE_SERVICE_URL,
    apiGateway: '/api',
    camGateway: process.env.REACT_APP_CAM_URL,
    galaxyRoot: '/galaxy',
    imageRoot: process.env.PUBLIC_URL
      ? `${process.env.PUBLIC_URL}${process.env.REACT_APP_CDN_SUFFIX}`
      : process.env.PUBLIC_URL,
    camRoot: '/packages/banyan/build/',
    ticketRoot: '/packages/mangifera/build/',
    intercomAppID: process.env.INTERCOM_APP_ID,
    mode: process.env.APP_MODE,
    chargeBeeEnv: process.env.CHARGEBEE_ENV,
    launchDarklyClientID: process.env.LAUNCHDARKLY_CLIENT_SITE_ID,
    cityLambdaURL: process.env.LAMBDA_CITY_URL,
    stripePublicKey: process.env.STRIPE_PUBLIC_KEY,
    cannyBoardToken: process.env.CANNY_BOARDTOKEN,
    cannyForumToken: process.env.CANNY_FORUMTOKEN,
    cannyAppId: process.env.CANNY_APPID,
    lambdaURL: process.env.LAMBDA_URL,
    websocketURL: process.env.WEBSOCKET_URL,
    dromoFrontendKey: process.env.DROMO_FRONT_END_KEY,
    sentryUrl: process.env.SENTRY_URL,
    mixpanelKey: process.env.MIXPANEL_KEY,
    useranalyticsDomain: process.env.USER_ANALYTICS_DOMAIN,
    staticFileVersion: process.env.STATIC_FILE_VERSION,
    mlGateway: process.env.REACT_APP_ML_URL,
    apiDomainUrl: process.env.DOMAIN_NAME_URL,
    // Coralogix RUM Configuration
    coralogixRumPublicKey: process.env.REACT_APP_CORALOGIX_RUM_PUBLIC_KEY,
    coralogixApplicationName: process.env.REACT_APP_CORALOGIX_APPLICATION_NAME,
    coralogixSubsystemName: process.env.REACT_APP_CORALOGIX_SUBSYSTEM_NAME,
    coralogixAppVersion: process.env.REACT_APP_CORALOGIX_APP_VERSION,
    coralogixDomain: process.env.REACT_APP_CORALOGIX_DOMAIN
  },
  beta: {
    base: '',
    frtenid: process.env.FRLANGTENID,
    public: process.env.REACT_APP_CDN_URL,
    loginRoot: process.env.REACT_APP_LOGIN_URL,
    logoutRoot: process.env.REACT_APP_LOGOUT_URL,
    cmsRoot: process.env.GRAPH_CMS_URL,
    accountsGateway: process.env.REACT_APP_ACCOUNTS_URL,
    accountsBasePath: process.env.REACT_APP_ACCOUNTS_BASE_URL,
    ticketingRoot: process.env.REACT_APP_TICKETING_URL,
    ticketGateway: process.env.REACT_APP_TICKET_URL,
    rmmGateway: process.env.REACT_APP_RMM_URL,
    mockTicketGateway: process.env.REACT_APP_MOCK_TICKET_GATEWAY,
    mockRMMGateway: process.env.REACT_APP_MOCK_RMM_GATEWAY,
    rmmRoot: process.env.REACT_APP_ROOT_RMM_URL,
    fileRoot: process.env.REACT_APP_FILE_SERVICE_URL,
    apiGateway: '/api',
    camGateway: process.env.REACT_APP_CAM_URL,
    galaxyRoot: '/galaxy',
    imageRoot: process.env.PUBLIC_URL
      ? `${process.env.PUBLIC_URL}${process.env.REACT_APP_CDN_SUFFIX}`
      : process.env.PUBLIC_URL,
    camRoot: '/packages/banyan/build/',
    ticketRoot: '/packages/mangifera/build/',
    intercomAppID: process.env.INTERCOM_APP_ID,
    mode: process.env.APP_MODE,
    chargeBeeEnv: process.env.CHARGEBEE_ENV,
    launchDarklyClientID: process.env.LAUNCHDARKLY_CLIENT_SITE_ID,
    cityLambdaURL: process.env.LAMBDA_CITY_URL,
    stripePublicKey: process.env.STRIPE_PUBLIC_KEY,
    cannyBoardToken: process.env.CANNY_BOARDTOKEN,
    cannyForumToken: process.env.CANNY_FORUMTOKEN,
    cannyAppId: process.env.CANNY_APPID,
    lambdaURL: process.env.LAMBDA_URL,
    websocketURL: process.env.WEBSOCKET_URL,
    dromoFrontendKey: process.env.DROMO_FRONT_END_KEY,
    sentryUrl: process.env.SENTRY_URL,
    mixpanelKey: process.env.MIXPANEL_KEY,
    useranalyticsDomain: process.env.USER_ANALYTICS_DOMAIN,
    staticFileVersion: process.env.STATIC_FILE_VERSION,
    mlGateway: process.env.REACT_APP_ML_URL,
    apiDomainUrl: process.env.DOMAIN_NAME_URL,
    // Coralogix RUM Configuration
    coralogixRumPublicKey: process.env.REACT_APP_CORALOGIX_RUM_PUBLIC_KEY,
    coralogixApplicationName: process.env.REACT_APP_CORALOGIX_APPLICATION_NAME,
    coralogixSubsystemName: process.env.REACT_APP_CORALOGIX_SUBSYSTEM_NAME,
    coralogixAppVersion: process.env.REACT_APP_CORALOGIX_APP_VERSION,
    coralogixDomain: process.env.REACT_APP_CORALOGIX_DOMAIN
  }
};

export default {
  ...stages[process.env.NODE_ENV]
};
